import { IcExport } from '@assets/icons/24x24';
import { Icon, IconButton } from '@chakra-ui/react';
import { Tooltip } from '@components/ui/tooltip';
import { createDownloadToast, exportFileOrDirectory } from '@utils/importExport.utils';
import { useIntl } from 'react-intl';

import { DownloadToastTypeEnum, FileDirectoryDownloadResponse } from '@/types/download.types';

type DownloadButtonProps = {
  label: string;
  loading: boolean;
  downloadTrigger: () => Promise<FileDirectoryDownloadResponse>;
  variant?: 'cockpitHeader';
};

export function DownloadButton({
  label,
  loading,
  downloadTrigger,
  variant = 'cockpitHeader',
}: Readonly<DownloadButtonProps>) {
  const { formatMessage } = useIntl();

  const downloadJson = async () => {
    try {
      const response = await downloadTrigger();
      exportFileOrDirectory(response);
    } catch (_) {
      createDownloadToast(DownloadToastTypeEnum.ERROR);
    }
  };

  return (
    <Tooltip content={formatMessage({ id: label })}>
      <IconButton aria-label="Download data" onClick={downloadJson} loading={loading} variant={variant} boxSize="56px">
        <Icon as={IcExport} boxSize="24px" />
      </IconButton>
    </Tooltip>
  );
}
